<div class="public-footer">
	<div class="container-fluid" *ngIf="!loadingLanguage">
		<div class="rodape" *ngIf="env.websiteUrl">
			<div class="copyright">© {{ currentYear }}. {{ 'allRightsReserved' | translate }}</div>
			<a class="brand" [href]="env.websiteUrl" [trackClick]="footerLinkType" [trackUrl]="env.websiteUrl"
				target="_blank" *ngIf="productInfo?.secondaryLogoUrl">
				<img [src]="productInfo?.secondaryLogoUrl" [alt]="productInfo?.name" height="27" loading="lazy" />
			</a>
		</div>
	</div>
</div>